var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "store-fields",
      class: { "single-column": !!_setup.appStoreListing },
    },
    [
      _c(_setup.CSelect, {
        attrs: {
          label: "Ecommerce Platform",
          options: _setup.storeTypeOptions,
          "model-transform": _setup.valueReducer,
          clearable: false,
          disabled: _vm.lockStoreType,
        },
        model: {
          value: _setup.storeTypeModel,
          callback: function ($$v) {
            _setup.storeTypeModel = $$v
          },
          expression: "storeTypeModel",
        },
      }),
      _vm._v(" "),
      !_setup.appStoreListing
        ? _c(_setup.ValidationProvider, {
            attrs: {
              rules: _setup.isAmazon
                ? "required|amazon-store-name"
                : "required|url",
              name: _setup.isAmazon ? "Store Name" : "Ecommerce URL",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(_setup.CInput, {
                        attrs: {
                          label: _setup.isAmazon
                            ? "Store Name*"
                            : "Ecommerce URL*",
                          placeholder: _setup.urlPlaceholder,
                          error: !!errors[0],
                          "error-msg": errors[0],
                        },
                        model: {
                          value: _setup.storeUrlModel,
                          callback: function ($$v) {
                            _setup.storeUrlModel = $$v
                          },
                          expression: "storeUrlModel",
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              1584898017
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }